import Swiper from 'swiper';
import { Pagination, Autoplay, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export function initTestimonials() {
    document.querySelectorAll('.testimonials-swiper').forEach((el) => {
        const pagination = el.querySelector('.swiper-pagination');

        new Swiper(el, {
            modules: [Pagination, Autoplay, A11y],
            slidesPerView: 3,
            spaceBetween: 24,
            loop: false,
            speed: 600,
            autoHeight: false,
            breakpoints: {
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
            autoplay: { delay: 7000, disableOnInteraction: false },
            pagination: pagination ? { el: pagination, clickable: true } : undefined,
            a11y: { enabled: true },
        });
    });
}

document.addEventListener('DOMContentLoaded', initTestimonials);
